import { render, staticRenderFns } from "./SortOptions.vue?vue&type=template&id=56594e78&scoped=true"
import script from "./SortOptions.vue?vue&type=script&lang=js"
export * from "./SortOptions.vue?vue&type=script&lang=js"
import style0 from "./SortOptions.vue?vue&type=style&index=0&id=56594e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56594e78",
  null
  
)

export default component.exports